import React, { useCallback, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import SimpleBackdrop from "utils/general";
import moment from "moment";
import { Column } from "primereact/column";
import { CommonConfig } from "CommonConfig";
import APIConstant from "utils/constant";
import api from "utils/api";
import { v4 as uuidv4 } from "uuid";
import { Dialog } from "primereact/dialog";
import cogoToast from "cogo-toast";

const Network = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState("");
  const [networkId, setNetworkId] = useState("");
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [networkList, setNetworkList] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccessData = localStorage.getItem("PageAccess");
    setUserId(data);
    setUserPageAccess(userPageAccessData);
    GetNetwork(data);
  }, []);

  const GetNetwork = (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetNetwork, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setNetworkList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const DeleteNetwork = async (e) => {
    try {
      let params = {
        NetworkId: networkId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeleteNetwork, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setNetworkId("");
            setShowDeleteModal(false);
            GetNetwork(userId);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleOpen = (item, type) => {
    if (type === "AddMaster") {
      props.history.push({
        pathname: "/admin/add-network",
        state: {
          NetworkId: item.NetworkId,
          Type: "Add",
          NetworkBranchId: uuidv4(),
        },
      });
    } else if (type === "EditMaster") {
      props.history.push({
        pathname: "/admin/add-network",
        state: {
          NetworkId: item.NetworkId,
          Type: "Edit",
          NetworkBranchId: item.NetworkBranchId,
        },
      });
    } else if (type === "DeleteMaster") {
      setNetworkId(item.NetworkId);
      setShowDeleteModal(true);
    }
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn p-d-flex p-jc-end">
        {userPageAccess?.includes("Edit Network") ? (
          <div onClick={(e) => handleOpen(rowData, "EditMaster")}>
            <i class="icon-editImage"></i>
          </div>
        ) : null}
        {userPageAccess?.includes("Delete Network") ? (
          <div onClick={(e) => handleOpen(rowData, "DeleteMaster")}>
            <i class="icon-delete"></i>{" "}
          </div>
        ) : null}
      </div>
    );
  };

  let filterGetMasterList = [];
  if (networkList.length) {
    filterGetMasterList = networkList;
    if (search) {
      // filterGetMasterList = filterGetMasterList.filter((x) => {
      //   // return x.GradeName.toLowerCase().indexOf(search.toLowerCase()) !== -1;
      // });
    }
  }

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-sort-amount-up"></i>
          <h2>Network</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-as-center p-position-relative">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!search ? <i className="icon-search"></i> : null}
          </div>
          {userPageAccess?.includes("Add Network") ? (
            <div>
              <div
                className="e-add-btn"
                onClick={(e) => handleOpen(e, "AddMaster")}
              >
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      <div className="custom-large-wb-table e-common-master-table">
        {loading === true ? (
          <div className="loading">
            <SimpleBackdrop />
          </div>
        ) : null}

        <DataTable
          className="main-table table-td"
          value={filterGetMasterList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={rowsPerPage}
          totalRecords={filterGetMasterList.length}
          rowsPerPageOptions={rowsPerPageOptions}
          globalFilter={search}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "30%" }}
          ></Column>
          <Column
            field="UserType"
            header="User Type"
            style={{ width: "30%" }}
          ></Column>
          <Column
            field="Company Name"
            header="Company Name"
            style={{ width: "30%" }}
            body={(rowData) => {
              return rowData.UserType === "Customer"
                ? rowData.CustomerDetails?.CustomerName ||
                    rowData.CustomerDetails?.ContactNo
                : rowData.UserType === "Staff"
                ? rowData.StaffDetails?.StaffName
                : rowData.CompanyDetails?.CompanyName;
            }}
          ></Column>

          <Column
            field="Action"
            header="Action"
            body={actionTemplate}
            style={{ width: "10%" }}
            headerClassName="p-d-flex p-jc-end"
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={showDeleteModal}
        className="dialog-popup"
        header={`Are you sure want to delete this network?`}
        draggable={false}
        onHide={() => {
          setShowDeleteModal(false);
          setNetworkId("");
        }}
        position="center"
      >
        <div className="p-d-flex p-ai-center p-jc-center dialog-footer1">
          <button
            className="e-error-btn"
            onClick={(e) => {
              setShowDeleteModal(false);
              setNetworkId("");
            }}
          >
            Cancel
          </button>
          <button className="primary-btn1" onClick={(e) => DeleteNetwork(e)}>
            Delete
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default Network;
